import Config from '../config/config';
import axios from 'axios';

const { baseURL } = Config.API;

const create = async (formData) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/expenses/',
    data: formData
  });
};

const update = async (_id, formData) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/expenses/${_id}`,
    data: formData
  });
};

const getExpenses = async (queryParams) => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/expenses/',
    params: queryParams
  });
};

const deleteExpenses = async (ids) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: '/expenses/',
    data: {
      expenseIds: ids
    }
  });
};

export default {
  create,
  update,
  getExpenses,
  deleteExpenses
};
